import * as React from 'react'
import {FC} from 'react'
import {observer} from 'mobx-react'
import {WidgetApi} from '../../../../lib/WidgetApi'
import {Countdown} from './Countdown'
import {IconSMSCountdown} from '../../../ui/Icons'
import {SmsPollView} from '../OverlaySmsPollBlock'
import {useStores} from '../../../../lib/MobXProvider'

///////////////////////////////////////////////////////////////////////////////

export type OverlaySmsPollCountdownProps = {
  changeView: (view: SmsPollView) => void
}

///////////////////////////////////////////////////////////////////////////////

export const OverlaySmsPollCountdown: FC<OverlaySmsPollCountdownProps> = observer(
  (props) => {
    const {changeView} = props
    const {api} = useStores<{api: WidgetApi}>()
    const cancel = () => api.forceCancelTransaction()
    const stop = () => api.epik.transactionStatusPoll.stop()
    const noSmsReceived = () => {
      stop()
      changeView(SmsPollView.CHANGE_NUMBER)
      api.ui.focusElementBySelector('.overlay-sms-poll-change-number input')
    }

    return (
      <div className="overlay-sms-poll-countdown">
        <div className="header">
          <div className="countdown-placeholder">
            <IconSMSCountdown />
            <div className="countdown">
              <Countdown counter={60 * 60 - 1} onFinish={cancel} />
            </div>
          </div>
        </div>
        <div className="main">
          <div className="subtitle">
            <h2 className="text">
              {api.trans('blocks.overlay_sms_poll_countdown.subtitle')}
            </h2>
          </div>
          <div
            className="text"
            dangerouslySetInnerHTML={{
              __html: api.trans('blocks.overlay_sms_poll_countdown.text_html'),
            }}
          />
        </div>
        <div className="actions">
          <button
            type="button"
            className="action-change-number"
            onClick={noSmsReceived}
          >
            <span className="link">
              {api.trans('blocks.overlay_sms_poll_countdown.no_sms')}
            </span>
          </button>
          <button type="button" className="action-cancel" onClick={cancel}>
            <span className="link">
              {api.trans('blocks.overlay_sms_poll_countdown.cancel')}
            </span>
          </button>
        </div>
      </div>
    )
  },
)
